module.exports = __webpack_public_path__ + "fonts/DM_Sans-400-latin-ext8.0d3827b.woff2";